import { createAction, props } from '@ngrx/store';

enum UiActionType {
  StartLoading = '[UI] Start Loading',
  StopLoading = '[UI] Stop Loading',
}

export const startLoadingAction = createAction(UiActionType.StartLoading);

export const stopLoadingAction = createAction(UiActionType.StopLoading);
